// Generated by AshTypescript
// Do not edit this file manually





export type AshDate = string;
export type UUID = string;
export type UUIDv7 = string;
export type UtcDateTimeUsec = string;

// BusinessUnit Schema
export type BusinessUnitResourceSchema = {
  __type: "Resource";
  __primitiveFields: "id" | "name";
  id: UUIDv7;
  name: string;
};



// AuditPlan Schema
export type AuditPlanResourceSchema = {
  __type: "Resource";
  __primitiveFields: "id" | "insertedAt" | "updatedAt" | "title" | "referenceYear" | "description" | "state" | "lastChangeBy" | "lastChangeAt" | "completionPercentage";
  id: UUIDv7;
  insertedAt: UtcDateTimeUsec;
  updatedAt: UtcDateTimeUsec;
  title: string;
  referenceYear: number;
  description: string | null;
  state: "draft" | "deferred";
  lastChangeBy: UUID;
  lastChangeAt: UtcDateTimeUsec;
  completionPercentage: number | null;
  assignments: { __type: "Relationship"; __array: true; __resource: AssignmentResourceSchema; };
};



// Assignment Schema
export type AssignmentResourceSchema = {
  __type: "Resource";
  __primitiveFields: "id" | "insertedAt" | "updatedAt" | "name" | "type" | "description" | "startDate" | "endDate" | "state" | "auditPlanId" | "businessUnitId" | "completionPercentage";
  id: UUIDv7;
  insertedAt: UtcDateTimeUsec;
  updatedAt: UtcDateTimeUsec;
  name: string;
  type: "regulatory_compliance" | "financial_audit" | "operational_review" | "it_security_assessment";
  description: string | null;
  startDate: AshDate | null;
  endDate: AshDate | null;
  state: "not_started";
  auditPlanId: UUID;
  businessUnitId: UUID;
  completionPercentage: number | null;
  auditPlan: { __type: "Relationship"; __resource: AuditPlanResourceSchema; };
  businessUnit: { __type: "Relationship"; __resource: BusinessUnitResourceSchema; };
};





export type BusinessUnitFilterInput = {
  and?: Array<BusinessUnitFilterInput>;
  or?: Array<BusinessUnitFilterInput>;
  not?: Array<BusinessUnitFilterInput>;

  id?: {
    eq?: UUIDv7;
    notEq?: UUIDv7;
    in?: Array<UUIDv7>;
  };

  name?: {
    eq?: string;
    notEq?: string;
    in?: Array<string>;
  };



};
export type AuditPlanFilterInput = {
  and?: Array<AuditPlanFilterInput>;
  or?: Array<AuditPlanFilterInput>;
  not?: Array<AuditPlanFilterInput>;

  id?: {
    eq?: UUIDv7;
    notEq?: UUIDv7;
    in?: Array<UUIDv7>;
  };

  insertedAt?: {
    eq?: UtcDateTimeUsec;
    notEq?: UtcDateTimeUsec;
    greaterThan?: UtcDateTimeUsec;
    greaterThanOrEqual?: UtcDateTimeUsec;
    lessThan?: UtcDateTimeUsec;
    lessThanOrEqual?: UtcDateTimeUsec;
    in?: Array<UtcDateTimeUsec>;
  };

  updatedAt?: {
    eq?: UtcDateTimeUsec;
    notEq?: UtcDateTimeUsec;
    greaterThan?: UtcDateTimeUsec;
    greaterThanOrEqual?: UtcDateTimeUsec;
    lessThan?: UtcDateTimeUsec;
    lessThanOrEqual?: UtcDateTimeUsec;
    in?: Array<UtcDateTimeUsec>;
  };

  title?: {
    eq?: string;
    notEq?: string;
    in?: Array<string>;
  };

  referenceYear?: {
    eq?: number;
    notEq?: number;
    greaterThan?: number;
    greaterThanOrEqual?: number;
    lessThan?: number;
    lessThanOrEqual?: number;
    in?: Array<number>;
  };

  description?: {
    eq?: string;
    notEq?: string;
    in?: Array<string>;
  };

  state?: {
    eq?: "draft" | "deferred";
    notEq?: "draft" | "deferred";
    in?: Array<"draft" | "deferred">;
  };

  completionPercentage?: {
    eq?: number;
    notEq?: number;
    greaterThan?: number;
    greaterThanOrEqual?: number;
    lessThan?: number;
    lessThanOrEqual?: number;
    in?: Array<number>;
  };


  assignments?: AssignmentFilterInput;

};
export type AssignmentFilterInput = {
  and?: Array<AssignmentFilterInput>;
  or?: Array<AssignmentFilterInput>;
  not?: Array<AssignmentFilterInput>;

  id?: {
    eq?: UUIDv7;
    notEq?: UUIDv7;
    in?: Array<UUIDv7>;
  };

  insertedAt?: {
    eq?: UtcDateTimeUsec;
    notEq?: UtcDateTimeUsec;
    greaterThan?: UtcDateTimeUsec;
    greaterThanOrEqual?: UtcDateTimeUsec;
    lessThan?: UtcDateTimeUsec;
    lessThanOrEqual?: UtcDateTimeUsec;
    in?: Array<UtcDateTimeUsec>;
  };

  updatedAt?: {
    eq?: UtcDateTimeUsec;
    notEq?: UtcDateTimeUsec;
    greaterThan?: UtcDateTimeUsec;
    greaterThanOrEqual?: UtcDateTimeUsec;
    lessThan?: UtcDateTimeUsec;
    lessThanOrEqual?: UtcDateTimeUsec;
    in?: Array<UtcDateTimeUsec>;
  };

  name?: {
    eq?: string;
    notEq?: string;
    in?: Array<string>;
  };

  type?: {
    eq?: "regulatory_compliance" | "financial_audit" | "operational_review" | "it_security_assessment";
    notEq?: "regulatory_compliance" | "financial_audit" | "operational_review" | "it_security_assessment";
    in?: Array<"regulatory_compliance" | "financial_audit" | "operational_review" | "it_security_assessment">;
  };

  description?: {
    eq?: string;
    notEq?: string;
    in?: Array<string>;
  };

  startDate?: {
    eq?: AshDate;
    notEq?: AshDate;
    greaterThan?: AshDate;
    greaterThanOrEqual?: AshDate;
    lessThan?: AshDate;
    lessThanOrEqual?: AshDate;
    in?: Array<AshDate>;
  };

  endDate?: {
    eq?: AshDate;
    notEq?: AshDate;
    greaterThan?: AshDate;
    greaterThanOrEqual?: AshDate;
    lessThan?: AshDate;
    lessThanOrEqual?: AshDate;
    in?: Array<AshDate>;
  };

  state?: {
    eq?: "not_started";
    notEq?: "not_started";
    in?: Array<"not_started">;
  };

  auditPlanId?: {
    eq?: UUID;
    notEq?: UUID;
    in?: Array<UUID>;
  };

  businessUnitId?: {
    eq?: UUID;
    notEq?: UUID;
    in?: Array<UUID>;
  };

  completionPercentage?: {
    eq?: number;
    notEq?: number;
    greaterThan?: number;
    greaterThanOrEqual?: number;
    lessThan?: number;
    lessThanOrEqual?: number;
    in?: Array<number>;
  };


  auditPlan?: AuditPlanFilterInput;

  businessUnit?: BusinessUnitFilterInput;

};


// Utility Types

// Resource schema constraint
type TypedSchema = {
  __type: "Resource" | "TypedMap" | "Union";
  __primitiveFields: string;
};

// Utility type to convert union to intersection
type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;

// Helper type to infer union field values, avoiding duplication between array and non-array unions
type InferUnionFieldValue<
  UnionSchema extends { __type: "Union"; __primitiveFields: any },
  FieldSelection extends any[],
> = UnionToIntersection<
  {
    [FieldIndex in keyof FieldSelection]: FieldSelection[FieldIndex] extends UnionSchema["__primitiveFields"]
      ? FieldSelection[FieldIndex] extends keyof UnionSchema
        ? { [P in FieldSelection[FieldIndex]]: UnionSchema[FieldSelection[FieldIndex]] }
        : never
      : FieldSelection[FieldIndex] extends Record<string, any>
        ? {
            [UnionKey in keyof FieldSelection[FieldIndex]]: UnionKey extends keyof UnionSchema
              ? UnionSchema[UnionKey] extends { __array: true; __type: "TypedMap"; __primitiveFields: infer TypedMapFields }
                ? FieldSelection[FieldIndex][UnionKey] extends any[]
                  ? Array<
                      UnionToIntersection<
                        {
                          [FieldIdx in keyof FieldSelection[FieldIndex][UnionKey]]: FieldSelection[FieldIndex][UnionKey][FieldIdx] extends TypedMapFields
                            ? FieldSelection[FieldIndex][UnionKey][FieldIdx] extends keyof UnionSchema[UnionKey]
                              ? { [P in FieldSelection[FieldIndex][UnionKey][FieldIdx]]: UnionSchema[UnionKey][P] }
                              : never
                            : never;
                        }[number]
                      >
                    > | null
                  : never
                : UnionSchema[UnionKey] extends { __type: "TypedMap"; __primitiveFields: infer TypedMapFields }
                  ? FieldSelection[FieldIndex][UnionKey] extends any[]
                    ? UnionToIntersection<
                        {
                          [FieldIdx in keyof FieldSelection[FieldIndex][UnionKey]]: FieldSelection[FieldIndex][UnionKey][FieldIdx] extends TypedMapFields
                            ? FieldSelection[FieldIndex][UnionKey][FieldIdx] extends keyof UnionSchema[UnionKey]
                              ? { [P in FieldSelection[FieldIndex][UnionKey][FieldIdx]]: UnionSchema[UnionKey][P] }
                              : never
                            : never;
                        }[number]
                      > | null
                    : never
                  : UnionSchema[UnionKey] extends TypedSchema
                    ? InferResult<UnionSchema[UnionKey], FieldSelection[FieldIndex][UnionKey]>
                    : never
              : never;
          }
        : never;
  }[number]
>;

type HasComplexFields<T extends TypedSchema> = keyof Omit<
  T,
  "__primitiveFields" | "__type" | T["__primitiveFields"]
> extends never
  ? false
  : true;

type ComplexFieldKeys<T extends TypedSchema> = keyof Omit<
  T,
  "__primitiveFields" | "__type" | T["__primitiveFields"]
>;

type LeafFieldSelection<T extends TypedSchema> = T["__primitiveFields"];

type ComplexFieldSelection<T extends TypedSchema> = {
  [K in ComplexFieldKeys<T>]?: T[K] extends {
    __type: "Relationship";
    __resource: infer Resource;
  }
    ? NonNullable<Resource> extends TypedSchema
      ? UnifiedFieldSelection<NonNullable<Resource>>[]
      : never
    : T[K] extends {
          __type: "ComplexCalculation";
          __returnType: infer ReturnType;
        }
      ? T[K] extends { __args: infer Args }
        ? NonNullable<ReturnType> extends TypedSchema
          ? {
              args: Args;
              fields: UnifiedFieldSelection<NonNullable<ReturnType>>[];
            }
          : { args: Args }
        : NonNullable<ReturnType> extends TypedSchema
          ? { fields: UnifiedFieldSelection<NonNullable<ReturnType>>[] }
          : never
      : T[K] extends { __type: "TypedMap" }
        ? NonNullable<T[K]> extends TypedSchema
          ? UnifiedFieldSelection<NonNullable<T[K]>>[]
          : never
        : T[K] extends { __type: "Union"; __primitiveFields: infer PrimitiveFields }
          ? T[K] extends { __array: true }
            ? (PrimitiveFields | {
                [UnionKey in keyof Omit<T[K], "__type" | "__primitiveFields" | "__array">]?: T[K][UnionKey] extends { __type: "TypedMap"; __primitiveFields: any }
                  ? T[K][UnionKey]["__primitiveFields"][]
                  : T[K][UnionKey] extends TypedSchema
                    ? UnifiedFieldSelection<T[K][UnionKey]>[]
                    : never;
              })[]
            : (PrimitiveFields | {
                [UnionKey in keyof Omit<T[K], "__type" | "__primitiveFields">]?: T[K][UnionKey] extends { __type: "TypedMap"; __primitiveFields: any }
                  ? T[K][UnionKey]["__primitiveFields"][]
                  : T[K][UnionKey] extends TypedSchema
                    ? UnifiedFieldSelection<T[K][UnionKey]>[]
                    : never;
              })[]
            : NonNullable<T[K]> extends TypedSchema
              ? UnifiedFieldSelection<NonNullable<T[K]>>[]
              : never;
};

// Main type: Use explicit base case detection to prevent infinite recursion
type UnifiedFieldSelection<T extends TypedSchema> =
  HasComplexFields<T> extends false
    ? LeafFieldSelection<T> // Base case: only primitives, no recursion
    : LeafFieldSelection<T> | ComplexFieldSelection<T>; // Recursive case

type InferFieldValue<
  T extends TypedSchema,
  Field,
> = Field extends T["__primitiveFields"]
  ? Field extends keyof T
    ? { [K in Field]: T[Field] }
    : never
  : Field extends Record<string, any>
    ? {
        [K in keyof Field]: K extends keyof T
          ? T[K] extends {
              __type: "Relationship";
              __resource: infer Resource;
            }
            ? NonNullable<Resource> extends TypedSchema
              ? T[K] extends { __array: true }
                ? Array<InferResult<NonNullable<Resource>, Field[K]>>
                : null extends Resource
                  ? InferResult<NonNullable<Resource>, Field[K]> | null
                  : InferResult<NonNullable<Resource>, Field[K]>
            : never
          : T[K] extends {
                __type: "ComplexCalculation";
                __returnType: infer ReturnType;
              }
            ? NonNullable<ReturnType> extends TypedSchema
              ? null extends ReturnType
                ? InferResult<NonNullable<ReturnType>, Field[K]["fields"]> | null
                : InferResult<NonNullable<ReturnType>, Field[K]["fields"]>
              : ReturnType
            : NonNullable<T[K]> extends { __type: "TypedMap"; __primitiveFields: infer TypedMapFields }
              ? NonNullable<T[K]> extends { __array: true }
                ? Field[K] extends any[]
                  ? null extends T[K]
                    ? Array<
                        UnionToIntersection<
                          {
                            [FieldIndex in keyof Field[K]]: Field[K][FieldIndex] extends infer E
                              ? E extends TypedMapFields
                                ? E extends keyof NonNullable<T[K]>
                                  ? { [P in E]: NonNullable<T[K]>[P] }
                                  : never
                                : E extends Record<string, any>
                                  ? {
                                      [NestedKey in keyof E]: NestedKey extends keyof NonNullable<T[K]>
                                        ? NonNullable<NonNullable<T[K]>[NestedKey]> extends TypedSchema
                                          ? null extends NonNullable<T[K]>[NestedKey]
                                            ? InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]> | null
                                            : InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]>
                                          : never
                                        : never;
                                    }
                                  : E extends keyof NonNullable<T[K]>
                                    ? { [P in E]: NonNullable<T[K]>[P] }
                                    : never
                              : never;
                          }[number]
                        >
                      > | null
                    : Array<
                        UnionToIntersection<
                          {
                            [FieldIndex in keyof Field[K]]: Field[K][FieldIndex] extends infer E
                              ? E extends TypedMapFields
                                ? E extends keyof NonNullable<T[K]>
                                  ? { [P in E]: NonNullable<T[K]>[P] }
                                  : never
                                : E extends Record<string, any>
                                  ? {
                                      [NestedKey in keyof E]: NestedKey extends keyof NonNullable<T[K]>
                                        ? NonNullable<NonNullable<T[K]>[NestedKey]> extends TypedSchema
                                          ? null extends NonNullable<T[K]>[NestedKey]
                                            ? InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]> | null
                                            : InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]>
                                          : never
                                        : never;
                                    }
                                  : E extends keyof NonNullable<T[K]>
                                    ? { [P in E]: NonNullable<T[K]>[P] }
                                    : never
                              : never;
                          }[number]
                        >
                      >
                  : never
                : Field[K] extends any[]
                  ? null extends T[K]
                    ? UnionToIntersection<
                        {
                          [FieldIndex in keyof Field[K]]: Field[K][FieldIndex] extends infer E
                            ? E extends TypedMapFields
                              ? E extends keyof NonNullable<T[K]>
                                ? { [P in E]: NonNullable<T[K]>[P] }
                                : never
                              : E extends Record<string, any>
                                ? {
                                    [NestedKey in keyof E]: NestedKey extends keyof NonNullable<T[K]>
                                      ? NonNullable<NonNullable<T[K]>[NestedKey]> extends TypedSchema
                                        ? null extends NonNullable<T[K]>[NestedKey]
                                          ? InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]> | null
                                          : InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]>
                                        : never
                                      : never;
                                  }
                                : E extends keyof NonNullable<T[K]>
                                  ? { [P in E]: NonNullable<T[K]>[P] }
                                  : never
                            : never;
                        }[number]
                      > | null
                    : UnionToIntersection<
                        {
                          [FieldIndex in keyof Field[K]]: Field[K][FieldIndex] extends infer E
                            ? E extends TypedMapFields
                              ? E extends keyof T[K]
                                ? { [P in E]: T[K][P] }
                                : never
                              : E extends Record<string, any>
                                ? {
                                    [NestedKey in keyof E]: NestedKey extends keyof NonNullable<T[K]>
                                      ? NonNullable<NonNullable<T[K]>[NestedKey]> extends TypedSchema
                                        ? null extends NonNullable<T[K]>[NestedKey]
                                          ? InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]> | null
                                          : InferResult<NonNullable<NonNullable<T[K]>[NestedKey]>, E[NestedKey]>
                                        : never
                                      : never;
                                  }
                                : E extends keyof NonNullable<T[K]>
                                  ? { [P in E]: NonNullable<T[K]>[P] }
                                  : never
                            : never;
                        }[number]
                      >
                  : never
              : T[K] extends { __type: "Union"; __primitiveFields: any }
                ? T[K] extends { __array: true }
                  ? {
                      [CurrentK in K]: T[CurrentK] extends { __type: "Union"; __primitiveFields: any }
                        ? Field[CurrentK] extends any[]
                          ? Array<InferUnionFieldValue<T[CurrentK], Field[CurrentK]>> | null
                          : never
                        : never
                    }
                  : {
                      [CurrentK in K]: T[CurrentK] extends { __type: "Union"; __primitiveFields: any }
                        ? Field[CurrentK] extends any[]
                          ? InferUnionFieldValue<T[CurrentK], Field[CurrentK]> | null
                          : never
                        : never
                    }
                  : NonNullable<T[K]> extends TypedSchema
                    ? null extends T[K]
                      ? InferResult<NonNullable<T[K]>, Field[K]> | null
                      : InferResult<NonNullable<T[K]>, Field[K]>
                    : never
          : never;
      }
    : never;

type InferResult<
  T extends TypedSchema,
  SelectedFields extends UnifiedFieldSelection<T>[] | undefined,
> = SelectedFields extends undefined
  ? {}
  : SelectedFields extends []
  ? {}
  : SelectedFields extends UnifiedFieldSelection<T>[]
  ? UnionToIntersection<
      {
        [K in keyof SelectedFields]: InferFieldValue<T, SelectedFields[K]>;
      }[number]
    >
  : {};

// Pagination conditional types
// Checks if a page configuration object has any pagination parameters
type HasPaginationParams<Page> =
  Page extends { offset: any } ? true :
  Page extends { after: any } ? true :
  Page extends { before: any } ? true :
  false;

// Infer which pagination type is being used from the page config
type InferPaginationType<Page> =
  Page extends { offset: any } ? "offset" :
  Page extends { after: any } | { before: any } ? "keyset" :
  never;

// Returns either non-paginated (array) or paginated result based on page params
// For single pagination type support (offset-only or keyset-only)
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ConditionalPaginatedResult<
  Page,
  RecordType,
  PaginatedType
> = Page extends undefined
  ? RecordType
  : HasPaginationParams<Page> extends true
    ? PaginatedType
    : RecordType;

// For actions supporting both offset and keyset pagination
// Infers the specific pagination type based on which params were passed
type ConditionalPaginatedResultMixed<
  Page,
  RecordType,
  OffsetType,
  KeysetType
> = Page extends undefined
  ? RecordType
  : HasPaginationParams<Page> extends true
    ? InferPaginationType<Page> extends "offset"
      ? OffsetType
      : InferPaginationType<Page> extends "keyset"
        ? KeysetType
        : OffsetType | KeysetType  // Fallback to union if can't determine
    : RecordType;

export type SuccessDataFunc<T extends (...args: any[]) => Promise<any>> = Extract<
  Awaited<ReturnType<T>>,
  { success: true }
>["data"];


export type ErrorData<T extends (...args: any[]) => Promise<any>> = Extract<
  Awaited<ReturnType<T>>,
  { success: false }
>["errors"];

/**
 * Represents an error from an unsuccessful RPC call.
 *
 * This type matches the error structure defined in the AshTypescript.Rpc.Error protocol.
 *
 * @example
 * const error: AshRpcError = {
 *   type: "invalid_changes",
 *   message: "Invalid value for field %{field}",
 *   shortMessage: "Invalid changes",
 *   vars: { field: "email" },
 *   fields: ["email"],
 *   path: ["user", "email"],
 *   details: { suggestion: "Provide a valid email address" }
 * }
 */
export type AshRpcError = {
  /** Machine-readable error type (e.g., "invalid_changes", "not_found") */
  type: string;
  /** Full error message (may contain template variables like %{key}) */
  message: string;
  /** Concise version of the message */
  shortMessage: string;
  /** Variables to interpolate into the message template */
  vars: Record<string, any>;
  /** List of affected field names (for field-level errors) */
  fields: string[];
  /** Path to the error location in the data structure */
  path: string[];
  /** Optional map with extra details (e.g., suggestions, hints) */
  details?: Record<string, any>;
}

/**
 * Represents the result of a validation RPC call.
 *
 * All validation actions return this same structure, indicating either
 * successful validation or a list of validation errors.
 *
 * @example
 * // Successful validation
 * const result: ValidationResult = { success: true };
 *
 * // Failed validation
 * const result: ValidationResult = {
 *   success: false,
 *   errors: [
 *     {
 *       type: "required",
 *       message: "is required",
 *       shortMessage: "Required field",
 *       vars: { field: "email" },
 *       fields: ["email"],
 *       path: []
 *     }
 *   ]
 * };
 */
export type ValidationResult =
  | { success: true }
  | { success: false; errors: AshRpcError[]; };





// Helper Functions

/**
 * Configuration options for action RPC requests
 */
export interface ActionConfig {
  // Request data
  input?: Record<string, any>;
  identity?: any;
  fields?: Array<string | Record<string, any>>; // Field selection
  filter?: Record<string, any>; // Filter options (for reads)
  sort?: string; // Sort options
  page?:
    | {
        // Offset-based pagination
        limit?: number;
        offset?: number;
        count?: boolean;
      }
    | {
        // Keyset pagination
        limit?: number;
        after?: string;
        before?: string;
      };

  // Metadata
  metadataFields?: ReadonlyArray<string>;

  // HTTP customization
  headers?: Record<string, string>; // Custom headers
  fetchOptions?: RequestInit; // Fetch options (signal, cache, etc.)
  customFetch?: (
    input: RequestInfo | URL,
    init?: RequestInit,
  ) => Promise<Response>;

  // Multitenancy
  tenant?: string; // Tenant parameter

  // Hook context
  hookCtx?: Record<string, any>;
}

/**
 * Configuration options for validation RPC requests
 */
export interface ValidationConfig {
  // Request data
  input?: Record<string, any>;

  // HTTP customization
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (
    input: RequestInfo | URL,
    init?: RequestInit,
  ) => Promise<Response>;

  // Hook context
  hookCtx?: Record<string, any>;
}




/**
 * Gets the CSRF token from the page's meta tag
 * Returns null if no CSRF token is found
 */
export function getPhoenixCSRFToken(): string | null {
  return document
    ?.querySelector("meta[name='csrf-token']")
    ?.getAttribute("content") || null;
}

/**
 * Builds headers object with CSRF token for Phoenix applications
 * Returns headers object with X-CSRF-Token (if available)
 */
export function buildCSRFHeaders(headers: Record<string, string> = {}): Record<string, string> {
  const csrfToken = getPhoenixCSRFToken();
  if (csrfToken) {
    headers["X-CSRF-Token"] = csrfToken;
  }

  return headers;
}

/**
 * Internal helper function for making action RPC requests
 * Handles hooks, request configuration, fetch execution, and error handling
 * @param config Configuration matching ActionConfig
 */
async function executeActionRpcRequest<T>(
  payload: Record<string, any>,
  config: ActionConfig
): Promise<T> {
    const processedConfig = config;

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...config.headers,
    ...processedConfig.headers,
  };

  const fetchFunction = config.customFetch || processedConfig.customFetch || fetch;
  const fetchOptions: RequestInit = {
    ...config.fetchOptions,
    ...processedConfig.fetchOptions,
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  };

  const response = await fetchFunction("/rpc/run", fetchOptions);
  const result = response.ok ? await response.json() : null;


  if (!response.ok) {
    return {
      success: false,
      errors: [
        {
          type: "network_error",
          message: `Network request failed: ${response.statusText}`,
          shortMessage: "Network error",
          vars: { statusCode: response.status, statusText: response.statusText },
          fields: [],
          path: [],
          details: { statusCode: response.status }
        }
      ],
    } as T;
  }

  return result as T;
}


/**
 * Internal helper function for making validation RPC requests
 * Handles hooks, request configuration, fetch execution, and error handling
 * @param config Configuration matching ValidationConfig
 */
async function executeValidationRpcRequest<T>(
  payload: Record<string, any>,
  config: ValidationConfig
): Promise<T> {
    const processedConfig = config;

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...config.headers,
    ...processedConfig.headers,
  };

  const fetchFunction = config.customFetch || processedConfig.customFetch || fetch;
  const fetchOptions: RequestInit = {
    ...config.fetchOptions,
    ...processedConfig.fetchOptions,
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  };

  const response = await fetchFunction("/rpc/validate", fetchOptions);
  const result = response.ok ? await response.json() : null;


  if (!response.ok) {
    return {
      success: false,
      errors: [
        {
          type: "network_error",
          message: `Network request failed: ${response.statusText}`,
          shortMessage: "Network error",
          vars: { statusCode: response.status, statusText: response.statusText },
          fields: [],
          path: [],
          details: { statusCode: response.status }
        }
      ],
    } as T;
  }

  return result as T;
}









export type ListBusinessUnitsFields = UnifiedFieldSelection<BusinessUnitResourceSchema>[];


export type InferListBusinessUnitsResult<
  Fields extends ListBusinessUnitsFields | undefined,
  Page extends ListBusinessUnitsConfig["page"] = undefined
> = ConditionalPaginatedResultMixed<Page, Array<InferResult<BusinessUnitResourceSchema, Fields>>, {
  results: Array<InferResult<BusinessUnitResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  offset: number;
  count?: number | null;
  type: "offset";
}, {
  results: Array<InferResult<BusinessUnitResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  after: string | null;
  before: string | null;
  previousPage: string;
  nextPage: string;
  count?: number | null;
  type: "keyset";
}>;

export type ListBusinessUnitsConfig = {
  fields: ListBusinessUnitsFields;
  filter?: BusinessUnitFilterInput;
  sort?: string;
  page?: (
    {
      limit?: number;
      offset?: number;
      count?: boolean;
    } | {
      limit?: number;
      after?: string;
      before?: string;
    }
  );
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
};

export type ListBusinessUnitsResult<Fields extends ListBusinessUnitsFields, Page extends ListBusinessUnitsConfig["page"] = undefined> = | { success: true; data: InferListBusinessUnitsResult<Fields, Page>; }
| { success: false; errors: AshRpcError[]; }

;

export async function listBusinessUnits<Fields extends ListBusinessUnitsFields, Config extends ListBusinessUnitsConfig = ListBusinessUnitsConfig>(
  config: Config & { fields: Fields }
): Promise<ListBusinessUnitsResult<Fields, Config["page"]>> {
  const payload = {
    action: "list_business_units",
    ...(config.fields !== undefined && { fields: config.fields }),
    ...(config.filter && { filter: config.filter }),
    ...(config.sort && { sort: config.sort }),
    ...(config.page && { page: config.page })
  };

  return executeActionRpcRequest<ListBusinessUnitsResult<Fields, Config["page"]>>(
    payload,
    config
  );
}


export async function validateListBusinessUnits(
  config: {
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "list_business_units"
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type ListAuditPlansFields = UnifiedFieldSelection<AuditPlanResourceSchema>[];


export type InferListAuditPlansResult<
  Fields extends ListAuditPlansFields | undefined,
  Page extends ListAuditPlansConfig["page"] = undefined
> = ConditionalPaginatedResultMixed<Page, Array<InferResult<AuditPlanResourceSchema, Fields>>, {
  results: Array<InferResult<AuditPlanResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  offset: number;
  count?: number | null;
  type: "offset";
}, {
  results: Array<InferResult<AuditPlanResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  after: string | null;
  before: string | null;
  previousPage: string;
  nextPage: string;
  count?: number | null;
  type: "keyset";
}>;

export type ListAuditPlansConfig = {
  fields: ListAuditPlansFields;
  filter?: AuditPlanFilterInput;
  sort?: string;
  page?: (
    {
      limit?: number;
      offset?: number;
      count?: boolean;
    } | {
      limit?: number;
      after?: string;
      before?: string;
    }
  );
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
};

export type ListAuditPlansResult<Fields extends ListAuditPlansFields, Page extends ListAuditPlansConfig["page"] = undefined> = | { success: true; data: InferListAuditPlansResult<Fields, Page>; }
| { success: false; errors: AshRpcError[]; }

;

export async function listAuditPlans<Fields extends ListAuditPlansFields, Config extends ListAuditPlansConfig = ListAuditPlansConfig>(
  config: Config & { fields: Fields }
): Promise<ListAuditPlansResult<Fields, Config["page"]>> {
  const payload = {
    action: "list_audit_plans",
    ...(config.fields !== undefined && { fields: config.fields }),
    ...(config.filter && { filter: config.filter }),
    ...(config.sort && { sort: config.sort }),
    ...(config.page && { page: config.page })
  };

  return executeActionRpcRequest<ListAuditPlansResult<Fields, Config["page"]>>(
    payload,
    config
  );
}


export async function validateListAuditPlans(
  config: {
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "list_audit_plans"
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type GetAuditPlanInput = {
  id?: UUIDv7;
};

export type GetAuditPlanFields = UnifiedFieldSelection<AuditPlanResourceSchema>[];
export type InferGetAuditPlanResult<
  Fields extends GetAuditPlanFields,
> = InferResult<AuditPlanResourceSchema, Fields> | null;

export type GetAuditPlanResult<Fields extends GetAuditPlanFields> = | { success: true; data: InferGetAuditPlanResult<Fields>; }
| { success: false; errors: AshRpcError[]; }

;

export async function getAuditPlan<Fields extends GetAuditPlanFields>(
  config: {
  input?: GetAuditPlanInput;
  fields: Fields;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<GetAuditPlanResult<Fields>> {
  const payload = {
    action: "get_audit_plan",
    input: config.input,
    ...(config.fields !== undefined && { fields: config.fields })
  };

  return executeActionRpcRequest<GetAuditPlanResult<Fields>>(
    payload,
    config
  );
}


export async function validateGetAuditPlan(
  config: {
  input?: GetAuditPlanInput;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "get_audit_plan",
    input: config.input
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type CreateAuditPlanInput = {
  title: string;
  referenceYear: number;
  description?: string | null;
};

export type CreateAuditPlanFields = UnifiedFieldSelection<AuditPlanResourceSchema>[];

export type InferCreateAuditPlanResult<
  Fields extends CreateAuditPlanFields | undefined,
> = InferResult<AuditPlanResourceSchema, Fields>;

export type CreateAuditPlanResult<Fields extends CreateAuditPlanFields | undefined = undefined> = | { success: true; data: InferCreateAuditPlanResult<Fields>; }
| { success: false; errors: AshRpcError[]; }

;

export async function createAuditPlan<Fields extends CreateAuditPlanFields | undefined = undefined>(
  config: {
  input: CreateAuditPlanInput;
  fields?: Fields;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<CreateAuditPlanResult<Fields extends undefined ? [] : Fields>> {
  const payload = {
    action: "create_audit_plan",
    input: config.input,
    ...(config.fields !== undefined && { fields: config.fields })
  };

  return executeActionRpcRequest<CreateAuditPlanResult<Fields extends undefined ? [] : Fields>>(
    payload,
    config
  );
}


export async function validateCreateAuditPlan(
  config: {
  input: CreateAuditPlanInput;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "create_audit_plan",
    input: config.input
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}



export type DeleteAuditPlanResult = | { success: true; data: {}; }
| { success: false; errors: AshRpcError[]; }

;

export async function deleteAuditPlan(
  config: {
  identity: UUIDv7;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<DeleteAuditPlanResult> {
  const payload = {
    action: "delete_audit_plan",
    identity: config.identity
  };

  return executeActionRpcRequest<DeleteAuditPlanResult>(
    payload,
    config
  );
}


export async function validateDeleteAuditPlan(
  config: {
  identity: UUIDv7 | string;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "delete_audit_plan",
    identity: config.identity
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type DeferAuditPlanFields = UnifiedFieldSelection<AuditPlanResourceSchema>[];

export type InferDeferAuditPlanResult<
  Fields extends DeferAuditPlanFields | undefined,
> = InferResult<AuditPlanResourceSchema, Fields>;

export type DeferAuditPlanResult<Fields extends DeferAuditPlanFields | undefined = undefined> = | { success: true; data: InferDeferAuditPlanResult<Fields>; }
| { success: false; errors: AshRpcError[]; }

;

export async function deferAuditPlan<Fields extends DeferAuditPlanFields | undefined = undefined>(
  config: {
  identity: UUIDv7;
  fields?: Fields;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<DeferAuditPlanResult<Fields extends undefined ? [] : Fields>> {
  const payload = {
    action: "defer_audit_plan",
    identity: config.identity,
    ...(config.fields !== undefined && { fields: config.fields })
  };

  return executeActionRpcRequest<DeferAuditPlanResult<Fields extends undefined ? [] : Fields>>(
    payload,
    config
  );
}


export async function validateDeferAuditPlan(
  config: {
  identity: UUIDv7 | string;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "defer_audit_plan",
    identity: config.identity
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type ListAssignmentsFields = UnifiedFieldSelection<AssignmentResourceSchema>[];


export type InferListAssignmentsResult<
  Fields extends ListAssignmentsFields | undefined,
  Page extends ListAssignmentsConfig["page"] = undefined
> = ConditionalPaginatedResultMixed<Page, Array<InferResult<AssignmentResourceSchema, Fields>>, {
  results: Array<InferResult<AssignmentResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  offset: number;
  count?: number | null;
  type: "offset";
}, {
  results: Array<InferResult<AssignmentResourceSchema, Fields>>;
  hasMore: boolean;
  limit: number;
  after: string | null;
  before: string | null;
  previousPage: string;
  nextPage: string;
  count?: number | null;
  type: "keyset";
}>;

export type ListAssignmentsConfig = {
  fields: ListAssignmentsFields;
  filter?: AssignmentFilterInput;
  sort?: string;
  page?: (
    {
      limit?: number;
      offset?: number;
      count?: boolean;
    } | {
      limit?: number;
      after?: string;
      before?: string;
    }
  );
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
};

export type ListAssignmentsResult<Fields extends ListAssignmentsFields, Page extends ListAssignmentsConfig["page"] = undefined> = | { success: true; data: InferListAssignmentsResult<Fields, Page>; }
| { success: false; errors: AshRpcError[]; }

;

export async function listAssignments<Fields extends ListAssignmentsFields, Config extends ListAssignmentsConfig = ListAssignmentsConfig>(
  config: Config & { fields: Fields }
): Promise<ListAssignmentsResult<Fields, Config["page"]>> {
  const payload = {
    action: "list_assignments",
    ...(config.fields !== undefined && { fields: config.fields }),
    ...(config.filter && { filter: config.filter }),
    ...(config.sort && { sort: config.sort }),
    ...(config.page && { page: config.page })
  };

  return executeActionRpcRequest<ListAssignmentsResult<Fields, Config["page"]>>(
    payload,
    config
  );
}


export async function validateListAssignments(
  config: {
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "list_assignments"
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type CreateAssignmentInput = {
  name: string;
  type: "regulatory_compliance" | "financial_audit" | "operational_review" | "it_security_assessment";
  description?: string | null;
  startDate?: AshDate | null;
  endDate?: AshDate | null;
  state?: "not_started";
  auditPlanId: UUID;
  businessUnitId: UUID;
};

export type CreateAssignmentFields = UnifiedFieldSelection<AssignmentResourceSchema>[];

export type InferCreateAssignmentResult<
  Fields extends CreateAssignmentFields | undefined,
> = InferResult<AssignmentResourceSchema, Fields>;

export type CreateAssignmentResult<Fields extends CreateAssignmentFields | undefined = undefined> = | { success: true; data: InferCreateAssignmentResult<Fields>; }
| { success: false; errors: AshRpcError[]; }

;

export async function createAssignment<Fields extends CreateAssignmentFields | undefined = undefined>(
  config: {
  input: CreateAssignmentInput;
  fields?: Fields;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<CreateAssignmentResult<Fields extends undefined ? [] : Fields>> {
  const payload = {
    action: "create_assignment",
    input: config.input,
    ...(config.fields !== undefined && { fields: config.fields })
  };

  return executeActionRpcRequest<CreateAssignmentResult<Fields extends undefined ? [] : Fields>>(
    payload,
    config
  );
}


export async function validateCreateAssignment(
  config: {
  input: CreateAssignmentInput;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "create_assignment",
    input: config.input
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


export type GetAssignmentFields = UnifiedFieldSelection<AssignmentResourceSchema>[];
export type InferGetAssignmentResult<
  Fields extends GetAssignmentFields,
> = InferResult<AssignmentResourceSchema, Fields>;

export type GetAssignmentResult<Fields extends GetAssignmentFields> = | { success: true; data: InferGetAssignmentResult<Fields>; }
| { success: false; errors: AshRpcError[]; }

;

export async function getAssignment<Fields extends GetAssignmentFields>(
  config: {
  getBy: {
    id: UUIDv7;
  };
  fields: Fields;
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<GetAssignmentResult<Fields>> {
  const payload = {
    action: "get_assignment",
    getBy: config.getBy,
    ...(config.fields !== undefined && { fields: config.fields })
  };

  return executeActionRpcRequest<GetAssignmentResult<Fields>>(
    payload,
    config
  );
}


export async function validateGetAssignment(
  config: {
  headers?: Record<string, string>;
  fetchOptions?: RequestInit;
  customFetch?: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
}
): Promise<ValidationResult> {
  const payload = {
    action: "get_assignment"
  };

  return executeValidationRpcRequest<ValidationResult>(
    payload,
    config
  );
}


